import React, { useEffect, useState } from 'react';
import {
  CatalogFileCollection, CatalogFileSpotlightCollection, CatalogFileSpotlightObject, PriceData,
} from '../../../common/libraries/fileFormats/catalog/catalog';
import { useAppSelector } from '../../../Redux/Store/hooks';
import { CatalogObjectDisplayObject } from '../../Data/CatalogObjectDisplayObject';
import { POSCatalogData } from '../../../common/libraries/modelViewer/Data/POSCatalogData';
import { CatalogObjectDisplay } from '../../Util/CatalogObjectDisplay';
import { HomeView } from '../Views/HomeView';

type HomeControllerParameters = {
  catalog : POSCatalogData,
  collections : Array<CatalogFileCollection>,
  spotlight_collections : CatalogFileSpotlightCollection[],
  spotlight_objects : CatalogFileSpotlightObject[],
  clearCacheHandler : () => void,
};

export function HomeController(
  {
    catalog,
    collections,
    spotlight_collections,
    spotlight_objects,
    clearCacheHandler,
  }: HomeControllerParameters,
) : JSX.Element {

  // From the store, get the environment settings
  const environmentSettings = useAppSelector((state) => {
    return state.EnvironmentSettingsReducer;
  });

  const [
    spotlightCollections,
    setSpotlightCollections] = useState<Array<CatalogFileCollection>>([]);

  const [
    spotlightObjects,
    setSpotlightObjects] = useState<Array<CatalogObjectDisplayObject>>([]);

  useEffect(() => {

    // Grab the data of collections that should be in the spotlight

    const spotlightCollectionIds = Array.from(
      spotlight_collections,
      (highlightedCollection) => highlightedCollection.collectionId,
    );

    const collectionsToSpotlight = collections.filter(
      (collection) => spotlightCollectionIds.includes(collection.id),
    );

    setSpotlightCollections(collectionsToSpotlight);

    // Grab the data of objects that should be in the spotlight

    const arrSpotlightCatalogObjects : CatalogObjectDisplayObject[] = [];

    if (spotlight_objects) {
      spotlight_objects.forEach((spotlightObjectInfo, index) => {
        // Get the collection of this object
        const catalogObjectCollection = collections.find(
          (collection) => collection.id === spotlightObjectInfo.collectionId,
        );

        if (catalogObjectCollection) {
          // Grab the catalogObject
          const catalogObject = catalog.getModelByCollectionIDAndModelID(
            spotlightObjectInfo.collectionId,
            spotlightObjectInfo.objectId,
          );

          if (catalogObject && catalog.catalogFileInfo) {
            // Create a new object needed for the spotlight
            arrSpotlightCatalogObjects.push(
              CatalogObjectDisplay.CreateCatalogObjectDisplayObject2(
                catalogObjectCollection,
                catalogObject,
                index,
                environmentSettings.catalogInfoPath,
                catalog.catalogFileInfo.priceData || new Array<PriceData>(),
              ),
            );
          }
        }
      });
    }
    arrSpotlightCatalogObjects.sort((a, b) => {
      return a.displayPriority.localeCompare(b.displayPriority);
    });

    setSpotlightObjects(arrSpotlightCatalogObjects);

  }, [catalog, spotlight_objects, spotlight_collections]);

  return (
    <HomeView
      catalog={catalog}
      spotlightCollections={spotlightCollections}
      spotlightObjects={spotlightObjects}
      clearCacheHandler={clearCacheHandler}
    />
  );
}
